import { Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import CountryGuide from "@/pages/CountryGuide";
import EducationLoan from "@/pages/EducationLoan";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="page-error" role="alert" className="flex min-h-screen items-center justify-center bg-ink text-frost">
          <div className="text-center">
            <p className="font-display text-3xl">Something went wrong</p>
            <button
              className="mt-6 rounded-full bg-mint px-6 py-3 font-semibold text-ink"
              onClick={() => window.location.reload()}
              data-testid="error-reload-btn"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/destinations/:slug" element={<CountryGuide />} />
          <Route path="/education-loan" element={<EducationLoan />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" theme="dark" />
    </ErrorBoundary>
  );
}

export default App;
